import REST from '../rest';

const ENDPOINT = (reportId) => `api/v1/reports/${reportId}/filters`;

export const load = (reportId, params, filterId) => REST.get(ENDPOINT(reportId), filterId, params);
export const create = (reportId, data) => REST.post(ENDPOINT(reportId), data);
export const deleteFilter = (reportId, filterId) => REST.delete(ENDPOINT(reportId), filterId);
